import { render, staticRenderFns } from "./MarketplacePhysicalGiftsIndex.vue?vue&type=template&id=87b7c6ce&scoped=true&"
import script from "./MarketplacePhysicalGiftsIndex.vue?vue&type=script&lang=js&"
export * from "./MarketplacePhysicalGiftsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b7c6ce",
  null
  
)

export default component.exports